module.exports = __webpack_public_path__ + "36364c00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_avatar.png
// module id = 569
// module chunks = 0 1 2 3 4 5